type TransferStatusCount = {
	status: string;
	count: number;
};

export const transferBadgeStatus = {
	inProgress: "InProgress",
	pendingReceive: "PendingReceive",
	outstandingVirtuals: "OutstandingVirtuals",
} as const;

export const withOutstandingVirtualTransfersCount = (
	transfers: TransferStatusCount[] | undefined,
	count: number
): TransferStatusCount[] => [
	...(transfers ?? []).filter(
		({ status }) => status.toLowerCase() !== transferBadgeStatus.outstandingVirtuals.toLowerCase()
	),
	{ status: transferBadgeStatus.outstandingVirtuals, count },
];

export const getTransferBadgeCount = (transfers: TransferStatusCount[] | undefined): number =>
	(transfers ?? []).reduce(
		(total, { status, count }) =>
			status === transferBadgeStatus.inProgress ||
			status === transferBadgeStatus.pendingReceive ||
			status === transferBadgeStatus.outstandingVirtuals
				? total + count
				: total,
		0
	);
